import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import { Link } from 'react-router-dom'
import { startCase } from 'lodash'
import i18n from 'i18next'
import * as R from 'ramda'
import './QList.scss'
import SearchLayout from '../components/Layouts/Search'
import Button from '../UniformComponents/Button'
import Anchor from '../UniformComponents/Anchor'
import InfoAccordion from '../components/InfoAccordion'
import PanelAccordion from '../components/PanelAccordion'
import AppLoading from '../components/AppLoading'
import { PageSwitchTab, tabOptions } from '../components/PageSwitchTab'

@observer
class QListSearch extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showGuideAccordion: true,
            isQPanelOpen: {},
            isLoading: true,
        }
    }

    async componentDidMount() {
        const { store, qListSearchStore } = this.props

        store.breadcrumps = [{
            url: '/mandatoryquestions/select/',
            title: 'Mandatory Questions',
        }]

        await qListSearchStore.init()
        this.setQuestionPanelInitialState()
        this.setState({ isLoading: false })
    }

    setQuestionPanelInitialState = () => {
        const { qListSearchStore } = this.props
        const isQPanelOpen = {}
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < qListSearchStore.questionDataSet.length; i++) {
            isQPanelOpen[i] = true
        }
        this.setState({
            isQPanelOpen,
        })
    }

    setSelectedQuestionTitle = (title) => {
        const { store, qListSearchStore } = this.props
        qListSearchStore.selectedQuestionTitle = title
        store.breadcrumps = [
            {
                url: '/mandatoryquestions/select/',
                title: 'Mandatory Questions',
            },
        ]
    }

    toggleGuide = () => {
        this.setState((prevState) => ({
            showGuideAccordion: !prevState.showGuideAccordion,
        }))
    }

    toggleQuestionAccordion = (index) => {
        this.setState((prevState) => ({
            isQPanelOpen: {
                ...prevState.isQPanelOpen,
                [index]: !prevState.isQPanelOpen[index],
            },
        }))
    }

    replaceMergefield = (name) => {
        const { store } = this.props
        const clientName = R.path(['userData', 'clientName'], store)

        return name.replace(/\[companyname\]/gi, clientName)
    }

    renderGuide = () => {
        const { qListSearchStore } = this.props
        const { panels } = qListSearchStore
        return (
            <Fragment>
                <p className="getting-started-content">
                    <strong>
                        {i18n.t('mandatoryQuestions.mainHeader', 'Mandatory Questions')}
                    </strong>
                    {i18n.t('mandatoryQuestions.gettingStartedPanel.gettingStartedText')}
                </p>
                <div className="guide-inner-content">
                    {
                        Object.keys(panels).filter((key) => ['client', 'divisions', 'portfolios'].includes(key)).map((key) => (
                            panels[key].isVisible ? (
                                <Fragment>
                                    <div className="inner-content-item-wrapper">
                                        <p className="inner-content-header">
                                            {panels[key].title}
                                        </p>
                                        {/* eslint-disable-next-line max-len */}
                                        <p className="inner-content-paragraph">
                                            {panels[key].description}
                                        </p>
                                        <hr className="inner-content-divider" />
                                    </div>
                                </Fragment>
                            ) : null
                        ))
                    }
                </div>
                <div className="readmore-wrapper">
                    <div className="readmore-btn-wrapper">
                        <Anchor
                            cssClass="readmore-btn"
                            href="https://kb.explori.com/knowledge"
                            target="_blank"
                            isExternal
                        >
                            {i18n.t('read_more', 'Read more')}
                            <i className="fa fa-arrow-right" />
                        </Anchor>
                    </div>
                </div>
            </Fragment>
        )
    }

    renderCardItems = ({ name, id, oid }) => (
        <Fragment>
            <div className="question-accordion-inner-content">
                <div className="inner-most-content">
                    <div className="left">
                        <i className="fa fa-list-ul" />
                        <span>
                            {this.replaceMergefield(name)}
                        </span>
                    </div>
                    <div className="right">
                        <Link
                            to={`/mandatoryquestions/setup/${oid}/${id}`}
                            onClick={() => this.setSelectedQuestionTitle(name)}
                        >
                            <i className="fa-light fa-edit" />
                        </Link>
                    </div>
                </div>
            </div>
        </Fragment>
    )

    renderGuideAccordion = (showGuideAccordion, guideContent) => (
        <Fragment>
            <div className="guide-accordion-container" ref={this.guideAccordionRef}>
                <InfoAccordion
                    title={i18n.t('searchLayout.getStartGuide', 'Getting started guide')}
                    show={showGuideAccordion}
                    toggle={this.toggleGuide}
                >
                    {guideContent}
                </InfoAccordion>
            </div>
            <div className="readmore-wrapper">
                <hr className="readmore-divider" />
                <Button
                    cssClass="readmore-btn"
                    icon="fa-regular fa-arrows-rotate"
                    label={i18n.t('read_more', 'Read more')}
                />
            </div>
        </Fragment>
    )

    renderQuestionCard = (index, name, dataCollection) => {
        const { isQPanelOpen } = this.state
        const { qListSearchStore } = this.props
        const { panels } = qListSearchStore
        const panel = panels[name]
        return panel.isVisible()
            ? (
                <Fragment key={index}>
                    <PanelAccordion
                        title={name === 'client' ? i18n.t('mandatoryQuestions.questionsPanel.client.header') : R.pathOr(startCase(name), ['name'], panel)}
                        show={isQPanelOpen[index]}
                        toggle={() => this.toggleQuestionAccordion(index)}
                    >
                        {dataCollection.map((i) => this.renderCardItems(i))}
                    </PanelAccordion>
                </Fragment>
            ) : null
    }

    renderRightPanel = () => {
        const { qListSearchStore } = this.props
        const { questionDataSet } = qListSearchStore
        return (
            <Fragment>
                {questionDataSet.map((item, index) => (
                    this.renderQuestionCard(index, Object.keys(item), Object.values(item)[0])
                ))}
            </Fragment>
        )
    }

    render() {
        const {
            isLoading,
        } = this.state
        const {
            qListSearchStore, store, location, history,
        } = this.props
        return (isLoading ? <AppLoading text="Loading" />
            : (
                <div id="qlist">
                    <PageSwitchTab
                        userRole={store.userData.role}
                        location={location}
                        history={history}
                        tabOptions={tabOptions.questions}
                    />
                    <SearchLayout
                        pageTitle={i18n.t('mandatoryQuestions.mainHeader', 'Mandatory Questions')}
                        renderTablePanel={this.renderRightPanel}
                        renderGuide={this.renderGuide}
                        searchStore={qListSearchStore}
                        hasTopNav
                    />
                </div>
            )
        )
    }
}

export default QListSearch
